// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CookiesController from "./cookies_controller"
application.register("cookies", CookiesController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import RequestLogsController from "./request_logs_controller"
application.register("request-logs", RequestLogsController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import MermaidController from "./mermaid_controller"
application.register("mermaid", MermaidController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import DemoShowcaseController from "./demo_showcase_controller"
application.register("demo-showcase", DemoShowcaseController)

import WalletPassController from "./wallet_pass_controller"
application.register("wallet-pass", WalletPassController)

import SideSheetController from "./side_sheet_controller"
application.register("side-sheet", SideSheetController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import SidebarScrollController from "./sidebar_scroll_controller"
application.register("sidebar-scroll", SidebarScrollController)

import TableOfContentsController from "./table_of_contents_controller"
application.register("table-of-contents", TableOfContentsController)
